export const FALLBACK_STATES = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", "Goa", "Gujarat",
  "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala", "Madhya Pradesh",
  "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab", "Rajasthan",
  "Sikkim", "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal",
  "Andaman and Nicobar Islands", "Chandigarh", "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi", "Jammu and Kashmir", "Ladakh", "Lakshadweep", "Puducherry"
];

export const FALLBACK_CITIES = {
  "Maharashtra": ["Mumbai", "Pune", "Nagpur", "Thane", "Nashik", "Kalyan-Dombivli", "Vasai-Virar", "Aurangabad", "Navi Mumbai", "Solapur"],
  "Delhi": ["New Delhi", "North Delhi", "South Delhi", "East Delhi", "West Delhi", "Dwarka", "Rohini"],
  "Karnataka": ["Bengaluru", "Mysuru", "Hubballi-Dharwad", "Mangaluru", "Belagavi", "Davangere", "Ballari", "Vijayapura", "Shivamogga"],
  "Gujarat": ["Ahmedabad", "Surat", "Vadodara", "Rajkot", "Bhavnagar", "Jamnagar", "Gandhinagar", "Junagadh", "Gandhidham"],
  "Tamil Nadu": ["Chennai", "Coimbatore", "Madurai", "Tiruchirappalli", "Salem", "Tiruppur", "Erode", "Vellore", "Thoothukudi", "Nagercoil"],
  "Uttar Pradesh": ["Lucknow", "Kanpur", "Ghaziabad", "Agra", "Meerut", "Varanasi", "Allahabad", "Bareilly", "Aligarh", "Moradabad", "Noida"],
  "West Bengal": ["Kolkata", "Howrah", "Darjeeling", "Siliguri", "Asansol", "Durgapur", "Maheshtala", "Rajpur Sonarpur", "Gopalpur"]
};

let cachedStates = null;
const cachedCitiesMap = {};

export async function fetchStates() {
  if (cachedStates && cachedStates.length > 0) {
    return cachedStates;
  }
  try {
    const response = await fetch("https://countriesnow.space/api/v0.1/countries/states", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ country: "India" })
    });
    const result = await response.json();
    if (result && !result.error && result.data && result.data.states) {
      const statesList = result.data.states.map(s => s.name);
      cachedStates = statesList;
      return statesList;
    }
  } catch (err) {
    console.error("Failed to fetch states from API, using fallback list:", err);
  }
  cachedStates = FALLBACK_STATES;
  return FALLBACK_STATES;
}

export async function fetchCitiesForState(stateName) {
  if (!stateName) return [];
  if (cachedCitiesMap[stateName]) {
    return cachedCitiesMap[stateName];
  }
  try {
    const response = await fetch("https://countriesnow.space/api/v0.1/countries/state/cities", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ country: "India", state: stateName })
    });
    const result = await response.json();
    if (result && !result.error && result.data) {
      cachedCitiesMap[stateName] = result.data;
      return result.data;
    }
  } catch (err) {
    console.error(`Failed to fetch cities for ${stateName} from API, using fallback:`, err);
  }
  const fallback = FALLBACK_CITIES[stateName] || [];
  cachedCitiesMap[stateName] = fallback;
  return fallback;
}
